import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoney = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.3255 15.0833C14.4338 14.5917 13.8255 14.0833 13.8255 13.2917C13.8255 12.3833 14.6671 11.75 16.0755 11.75C17.5588 11.75 18.1088 12.4583 18.1588 13.5H20.0005C19.9421 12.0667 19.0671 10.75 17.3255 10.325V8.5H14.8255V10.3C13.2088 10.65 11.9088 11.7 11.9088 13.3083C11.9088 15.2333 13.5005 16.1917 15.8255 16.75C17.9088 17.25 18.3255 17.9833 18.3255 18.7583C18.3255 19.3333 17.9171 20.25 16.0755 20.25C14.3588 20.25 13.6838 19.4833 13.5921 18.5H11.7588C11.8588 20.325 13.2255 21.35 14.8255 21.6917V23.5H17.3255V21.7083C18.9505 21.4 20.2421 20.4583 20.2421 18.75C20.2421 16.3833 18.2171 15.575 16.3255 15.0833Z",
		fill: "#509F4E"
	})
});
export default SvgMoney;
